module.exports = __webpack_public_path__ + "static/media/T11-01.00c2a40a.svg";